import { useState, useMemo } from 'react';
import { Order } from '@/data/mockData';

export type SortField = 'id' | 'requestName' | 'duration' | 'volume' | 'price' | 'date' | 'owner' | 'status';
export type SortDirection = 'asc' | 'desc';

interface UseOrdersSortReturn {
  sortField: SortField;
  sortDirection: SortDirection;
  sortedOrders: Order[];
  handleSort: (field: SortField) => void;
}

export const useOrdersSort = (orders: Order[]): UseOrdersSortReturn => {
  const [sortField, setSortField] = useState<SortField>('date');
  const [sortDirection, setSortDirection] = useState<SortDirection>('desc');

  const sortedOrders = useMemo(() => {
    const sorted = [...orders].sort((a, b) => {
      let aVal: any = a[sortField];
      let bVal: any = b[sortField];
      
      if (sortField === 'date') {
        aVal = new Date(aVal).getTime();
        bVal = new Date(bVal).getTime();
      } else if (sortField === 'price' || sortField === 'volume' || sortField === 'duration') {
        aVal = Number(aVal) || 0;
        bVal = Number(bVal) || 0;
      } else {
        aVal = String(aVal).toLowerCase();
        bVal = String(bVal).toLowerCase();
      }
      
      if (aVal < bVal) return sortDirection === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [orders, sortField, sortDirection]);

  const handleSort = (field: SortField) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  return {
    sortField,
    sortDirection,
    sortedOrders,
    handleSort,
  };
};

